import { TENANT, Tenant } from './tenant';

/**
 * Header Logo
 */
const defaultHeaderLogo = '/logos/avelios_logo.svg';

const tenantToHeaderLogo = new Map<Tenant, string>([
  [Tenant.avelios, defaultHeaderLogo],
  [Tenant.sana, '/logos/sana-logo-white.png'],
]);

export const HEADER_LOGO: string = ((tenant: Tenant) => {
  const tenantHeaderLogo = tenantToHeaderLogo.get(tenant);

  if (tenantHeaderLogo) {
    return tenantHeaderLogo;
  }

  console.warn(`No header logo defined for tenant ${tenant}. Falling back to default.`);
  return defaultHeaderLogo;
})(TENANT);

/**
 * Footer Logo
 */
const defaultFooterLogo = '/logos/avelios_logo_large.png';

const tenantToFooterLogo = new Map<Tenant, string>([
  [Tenant.avelios, defaultFooterLogo],
  [Tenant.sana, '/logos/sana-logo-white.png'],
]);

export const FOOTER_LOGO: string = ((tenant: Tenant) => {
  const tenantFooterLogo = tenantToFooterLogo.get(tenant);

  if (tenantFooterLogo) {
    return tenantFooterLogo;
  }

  console.warn(`No footer logo defined for tenant ${tenant}. Falling back to default.`);
  return defaultFooterLogo;
})(TENANT);

/**
 * Login Logo
 *
 * Note: Used for login and registration page
 */
const defaultLoginLogo = '/logos/avelios_logo_large.svg';

const tenantToLoginLogo = new Map<Tenant, string>([
  [Tenant.avelios, defaultLoginLogo],
  [Tenant.sana, '/logos/sana-logo-blue.png'],
]);

export const LOGIN_LOGO: string = ((tenant: Tenant) => {
  const tenantLoginLogo = tenantToLoginLogo.get(tenant);

  if (tenantLoginLogo) {
    return tenantLoginLogo;
  }

  console.warn(`No login logo defined for tenant ${tenant}. Falling back to default.`);
  return defaultLoginLogo;
})(TENANT);
